"use strict";

define('rs/models/task.summary',['./abstract', './workflow', './person'], function (AbstractModel, Workflow, Person) {
  var TaskSummary = AbstractModel.extend({
    properties: ["peopleDisplayName", "taskEndedBy"],
    serverProperties: ["activitiTaskId", "assignment", "documentId", "groupName", "organizationName", "people", "response", "studyId", "taskBeginDate", "taskEndDate", "taskHistoryId", "taskName"]
  }, {
    rootURI: Workflow.rootURI,
    parsers: {
      'summary/document/:documentId': function summary_document_DocumentId(taskMap) {
        var taskSummaryMap = {},
          taskNames = _.keys(taskMap);
        for (var i = 0, len = taskNames.length, taskName; i < len; i++) {
          taskName = taskNames[i];
          if (!_.isEmpty(taskMap[taskName])) {
            taskSummaryMap[taskName] = this.models(this.processOrgGroups(taskMap[taskName]));
          }
        }
        return taskSummaryMap;
      },
      'history/document/:documentId': function history_document_DocumentId(taskMap) {
        for (taskName in taskMap) {
          taskMap[taskName] = this.models(this.processOrgGroups(taskMap[taskName]));
        }
        return taskMap;
      }
    },
    processOrgGroups: function processOrgGroups(taskSummaries) {
      var orgMap = {},
        orgName = null,
        previousTask = null,
        finalTaskSummaries = [];
      for (var i = 0, len = taskSummaries.length, taskSummary; i < len; i++) {
        taskSummary = taskSummaries[i];
        if (taskSummary.taskEndDate && taskSummary.person) {
          taskSummary.taskEndedBy = Person.model(taskSummary.person).getDisplayName();
        } else {
          taskSummary.taskEndedBy = null;
        }
        if (taskSummary.person) {
          taskSummary.people = [taskSummary.person];
          delete taskSummary.person;
        }
        if (!taskSummary.people) {
          taskSummary.people = [];
        }
        if (taskSummary.organizationName) {
          orgName = taskSummary.organizationName;
          orgMap[orgName] = orgMap[orgName] || {};
          previousTask = orgMap[orgName][taskSummary.activitiTaskId];
          if (previousTask) {
            if (taskSummary.taskEndDate > previousTask.taskEndDate) {
              for (prop in taskSummary) {
                if (prop == 'people') {
                  continue;
                }
                previousTask[prop] = taskSummary[prop];
              }
            }
            previousTask.people = previousTask.people.concat(taskSummary.people);
          } else {
            orgMap[orgName][taskSummary.activitiTaskId] = taskSummary;
            finalTaskSummaries.push(taskSummary);
          }
        } else {
          finalTaskSummaries.push(taskSummary);
        }
      }
      return finalTaskSummaries;
    },
    model: function model() {
      var model = AbstractModel.model.apply(this, arguments),
        people = model.getPeople();
      if (!_.isEmpty(people)) {
        model.setPeople(Person.models(people));
        model.setPeopleDisplayName(_.invoke(model.getPeople(), 'getDisplayName').join(', '));
      } else {
        model.setPeopleDisplayName('');
      }
      return model;
    },
    requestAll: function requestAll(documentId) {
      return this.get('summary/document/' + documentId);
    },
    requestHistory: function requestHistory(documentId) {
      return this.get('history/document/' + documentId);
    }
  });
  return TaskSummary;
});

